import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper, useTheme, useMediaQuery, Box } from "@mui/material";
import { PlayCircleOutline } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { MEMBERSHIP_COLORS } from "./MembershipStyles";
import { useLanguage } from "../../contexts/LanguageContext";

const BLUE  = MEMBERSHIP_COLORS.blue;
const MUTED = MEMBERSHIP_COLORS.muted;
const WHITE = MEMBERSHIP_COLORS.white;
const BORDER = MEMBERSHIP_COLORS.border;

const MobileBottomNav: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const theme     = useTheme();
  const isMobile  = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useLanguage();

  const navLinks = [
    { label: t.nav.classes,  icon: <PlayCircleOutline />, path: "/membership/classes"  },
    { label: t.nav.coaching, icon: <PlayCircleOutline />, path: "/membership/coaching" },
  ];

  if (!isMobile) return null;

  const getActive = (): number => {
    const p = location.pathname;
    if (p.startsWith("/membership/classes") || p.startsWith("/membership/video")) return 0;
    if (p.startsWith("/membership/coaching")) return 1;
    return -1;
  };

  const active = getActive();

  return (
    <Paper
      elevation={0}
      sx={{
        position:"fixed", bottom:0, left:0, right:0,
        zIndex: theme.zIndex.appBar,
        borderTop: `1px solid ${BORDER}`,
        paddingBottom:"env(safe-area-inset-bottom)",
        backgroundColor: WHITE,
        boxShadow:"0 -4px 24px rgba(21,101,192,0.08)",
      }}
    >
      <BottomNavigation
        showLabels
        value={active >= 0 ? active : false}
        onChange={(_, v) => navigate(navLinks[v].path)}
        sx={{
          height:64, backgroundColor:WHITE,
          "& .MuiBottomNavigationAction-root": {
            color:MUTED, minWidth:0, padding:"6px 0",
            transition:"all .2s ease",
          },
          "& .Mui-selected": {
            color:`${BLUE} !important`,
            "& .MuiBottomNavigationAction-label":{ fontSize:".7rem", fontWeight:700 },
            "& .MuiSvgIcon-root":{ color:BLUE },
          },
          "& .MuiBottomNavigationAction-label":{ fontSize:".65rem", marginTop:"3px" },
        }}
      >
        {navLinks.map((link, i) => (
          <BottomNavigationAction
            key={link.label}
            label={link.label}
            icon={
              <Box sx={{
                position:"relative",
                "& .MuiSvgIcon-root":{ fontSize:"1.3rem" },
              }}>
                {active === i && (
                  <Box sx={{
                    position:"absolute", top:-6, left:"50%", transform:"translateX(-50%)",
                    width:20, height:3, borderRadius:"0 0 3px 3px",
                    backgroundColor:BLUE,
                  }}/>
                )}
                {link.icon}
              </Box>
            }
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
